import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getMedications } from '../../services/api';

export interface MedicationsState {
  medicationsLists: {
    data: any;
    pagination: {
      total: number;
      page: number;
    };
    status: null | 'idle' | 'loading' | 'failed';
  };
  openAddMedications: boolean;
  medicationSelected: null | any;
}

const initialState: MedicationsState = {
  medicationsLists: {
    data: [],
    pagination: {
      total: 0,
      page: 1,
    },
    status: null,
  },
  openAddMedications: false,
  medicationSelected: null,
};

export const getMedicationsAsync: any | null = createAsyncThunk(
  'medications/getMedications',
  async (data: any, { getState, dispatch }) => {
    const state: any = getState();
    const params: any = {
      columnNameList:
        '"productId","internalproductId","commonNameGroupId","laboratoryTraderId","name","standardname","name_noaccent","galenicName","shortName","atccode","atccodemj"',
      tableName: 'product',
      name: data.medicine,
      c: 'es',
      tk: '4d1bf78de6dd5e2ec253c7420b872777',
      nbpage: data.size,
      page: data.page,
    };
    const response = await getMedications(data, params);
    return response;
  },
);

export const medicationsSlice = createSlice({
  name: 'medications',
  initialState,
  reducers: {
    setOpenAddMedications: (state, action: PayloadAction<boolean>) => {
      state.openAddMedications = action.payload;
    },
    setMedicationSelected: (state, action: PayloadAction<any>) => {
      state.medicationSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMedicationsAsync.pending, (state) => {
        state.medicationsLists.status = 'loading';
      })
      .addCase(getMedicationsAsync.fulfilled, (state, action) => {
        state.medicationsLists.data = action.payload.data.result.table;
        state.medicationsLists.pagination.total = action.payload?.data?.result.count[0].total;
        state.medicationsLists.status = 'idle';
      })
      .addCase(getMedicationsAsync.rejected, (state) => {
        state.medicationsLists.status = 'failed';
      });
  },
});

export const { setOpenAddMedications, setMedicationSelected } = medicationsSlice.actions;

export default medicationsSlice.reducer;
